import React, { useEffect } from 'react';
import './DialogModal.scss';


export interface DialogModalProps {
  open: boolean;
  onClose: (value?: string) => void;
  iconClass: string;
  buttonCancel?: string;
  buttonOk?: string;
  children: React.ReactChild;
  title?: string;
  large?: boolean;
  hasCloseAction?: boolean;
}

const DialogModal = (props: DialogModalProps) => {

  const { open, onClose, iconClass, buttonCancel, buttonOk, title, large, hasCloseAction, ...others } = props;

  const handleClose = () => {
    if (hasCloseAction) {
      onClose('close');
    } else {
      onClose('cancel');
    }
  }

  const handleCancel = () => {
    onClose('cancel');
  };

  const handleOk = () => {
    onClose('yes');
  };

  return (
    <>
      {open &&
        <div className="exit-dialog background">
          <div className={"popup" + (large ? ' large' : '')}>
            <div className="close" onClick={handleClose} ></div>
            <div className="body">
              <div className={`title-icon-container ${title ? 'with-title' : ''}`}>
                <div className={`icon ${iconClass}`}></div>
                {title && <div className="title">{title}</div>}
              </div>
              <div className="text">
                {props.children}
              </div>
            </div>
            <div className="footer">
              {buttonCancel && <div className="button cancel" onClick={handleCancel}>{buttonCancel}</div>}
              {buttonOk && <div className="button validate" onClick={handleOk}>{buttonOk}</div>}
            </div>
          </div>
        </div>
      }
    </>
  );

}

export default DialogModal;